module.exports = __webpack_public_path__ + "img/GH.4f42428a.svg";